export const BANK_CONNECTION_STATUS = {
  k_none: 'k_none',
  k_manual: 'k_manual',
  k_suspended: 'k_suspended',
  k_not_found: 'k_not_found',
}
